import React from 'react';
import {Styles} from '../../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import {Translate} from "../../../../config/Translate";
import {defaultVariabls} from "../../../../config/index";
import {withRouter} from "react-router-dom";
import { withSnackbar } from 'notistack';
import Grid from "@material-ui/core/Grid/Grid";
import {connect} from "trim-redux";
import Typography from "@material-ui/core/Typography/Typography";
import IconButton from "@material-ui/core/IconButton/IconButton";
import MoneyOffRoundedIcon from '@material-ui/icons/MoneyOffRounded';
import {currencySymbol, price} from "../../../../config/values";
import Link from "@material-ui/core/Link/Link";
import FeaturedPlayListOutlinedIcon from '@material-ui/icons/FeaturedPlayListOutlined';
import StorefrontOutlinedIcon from '@material-ui/icons/StorefrontOutlined';
import MonetizationOnOutlinedIcon from '@material-ui/icons/MonetizationOnOutlined';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import GetConfirmationText from "../../../components/elements/GetConfirmationText";
import Alert from "@material-ui/lab/Alert/Alert";
import AlertTitle from "@material-ui/lab/AlertTitle/AlertTitle";
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';
import axios from "axios";
import Tooltip from "@material-ui/core/Tooltip/Tooltip";
import InfoRoundedIcon from '@material-ui/icons/InfoRounded';
import FiberManualRecordRoundedIcon from "@material-ui/icons/FiberManualRecordRounded";

class SingleOrderItem extends React.Component {

    state = {
        item:this.props.item,
    };
    classes = this.props.classes;
    async changeProductVerification(verified){
        let {item} = this.state;
        let data = new FormData();
        data.append('id', item.id);
        data.append('verified', !!verified ? 1 : 0);

        let loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        await axios.post(`${defaultVariabls.url}/factor/change_product_verification`, data, config)
            .then(response => {
                this.props.reload();
            })
            .catch(error => {
                console.log(error.response)
                this.props.enqueueSnackbar(Translate.errorHappens, {
                    variant: 'error',
                });

            });

    }
    render(){
        let {product} = this.state.item;
        let {item} = this.state;
        return (
            <div className="order-items-holder" >
                {
                    !!product &&
                    <Link href={`${defaultVariabls.website}/product/${product.slug}`} target="_blank">
                        <img
                            src={`${defaultVariabls.uploads}/FileManager/${product.thumbnail.name}_book.${product.thumbnail.extension}`}
                            alt="img"
                            className="single-order-items-img-simple"
                        />
                    </Link>
                }
                <Typography>{Translate.product} <span className="result">{product.name}</span> {product.situation === "worked" && <span>({Translate.worked})</span>}</Typography>
                <Typography>
                    <FiberManualRecordRoundedIcon fontSize="small"/>
                </Typography>
                <Typography >{Translate.price}: <span className="result">{price(item.price*item.quantity)+" "+currencySymbol}</span> <span style={{color:this.props.primary_color,fontSize:11}}>({item.quantity+" "+Translate.number})</span></Typography>

                {
                    !!item.need_verification &&
                    <>
                        <Typography>
                            <FiberManualRecordRoundedIcon fontSize="small"/>
                        </Typography>
                        <Tooltip title={Translate.need_verification_description_user} arrow>
                            <Typography  style={{marginBottom:10}}>
                                <strong>{Translate.need_verification_hint}</strong>
                            </Typography>
                        </Tooltip>
                    </>

                }
                {
                    item.discount_price ?
                        <>
                            <Typography>
                                <FiberManualRecordRoundedIcon fontSize="small"/>
                            </Typography>
                            <Typography >{Translate.discount}: <span className="result" style={{color:"#f82e4e"}}>{price((parseInt(item.discount_price))*item.quantity)+" "+currencySymbol}</span></Typography>
                        </>
                        : null
                }
            </div>
        );
    }
}

const mstp = state => ({
    isAuth: state.isAuth,
    user: state.user,
    primary_color: state.primary_color
});
export default withRouter(withSnackbar(withStyles(Styles)(connect(mstp)(SingleOrderItem))));